<template>
  <header class="header">
    <div class="header__main">
      <div class="header__main__left">
        <h1 class="logo" @click="$router.push('/')"><img src="@/assets/image/logo.png" alt="logo"></h1>
        <strong class="title" @click="$router.push('/')">和计划心理</strong>
        <em class="subtitle">专注心理教育27年</em>
      </div>
      <div class="header__main__right">
        <div class="download">
          <el-popover trigger="hover" popper-class="download-app-popper">
            <div>
              <img src="https://cgzd.oss-cn-beijing.aliyuncs.com/static/cgzd/footer/mp-hjh.png" alt="和计划心理小程序">
              <p>扫一扫</p>
              <!-- <p>安装和计划心理APP</p> -->
              <p>随时随地想学就学</p>
            </div>
            <span slot="reference">和计划心理小程序</span>
          </el-popover>
        </div>
        <div class="user">
          <el-popover trigger="hover" popper-class="user-app-popper">
            <div>
              <span @click="userInfo">个人信息</span>
              <div class="line"></div>
              <span @click="logoutTip">退出登录</span>
            </div>
            <span slot="reference"><img class="avatar" :src="userAvatar" alt="作者" srcset=""></span>
          </el-popover>
        </div>
      </div>
    </div>
    <ConfirmDialog :isShowConfirm="isShowDialog" title="登出提示" content="是否确认退出登录" @handleClose="isShowDialog = false" @handleConfirm="logout"></ConfirmDialog>
  </header>
</template>

<script>
import { tokenStore } from "@/store/user.js";
export default {
  name: 'LayoutHeader',
  data() {
    return {
      store: tokenStore(),
      isShowDialog: false, // 登出提示弹窗
      userAvatar: '' // 用户头像
    }
  },
  mounted() {
    const avatar = this.store.getUserInfo.avatar
    if (!avatar || avatar == '') this.userAvatar = 'https://static.hejihua.com/middle/app/study/images/header/no-login.png'
    else this.userAvatar = avatar
  },

  methods: {
    // 个人信息
    userInfo() {
      this.$router.push('/my/account')
    },
    // 退出登录提示框
    logoutTip() {
      this.isShowDialog = true
    },
    // 退出登录(前端登出)
    logout() {
      this.store.setToken('')
      this.$cookies.set('token', '')
      this.$router.go(0)
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  z-index: 1999;
  background: #ffffff;
  &__main {
    margin: 0 auto;
    width: $main-max-width;
    height: $header-height;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &__left {
      padding-left: $header-logo-size;
      .logo {
        display: inline-block;
        cursor: pointer;
        img {
          position: absolute;
          top: 10px;
          left: 0;
          width: $header-logo-size;
        }
      }
      .title {
        font-size: 16px;
        font-weight: 500;
        font-family: $font-family-PingFangMedium;
        margin-right: 5px;
        cursor: pointer;
      }
      .subtitle {
        color: $grey-font-color;
        font-size: $small-font-size;
      }
    }
    &__right {
      display: flex;
      align-items: center;
      .download {
        cursor: pointer;
        margin-right: 40px;
        font-family: $font-family-PingFangMedium;
      }
      .user {
        display: flex;
        align-items: center;
        height: 36px;
        .avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
        }
        span {
          height: 36px;
        }
      }
    }
  }
}
</style>